import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { debugLog } from '../../lib/debugLog';
import { LoadingGateRecovery } from './LoadingGateRecovery';

interface ProtectedRouteProps {
  requireAdmin?: boolean;
  requireSuperAdmin?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ requireAdmin = false, requireSuperAdmin = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    debugLog('info', 'ProtectedRoute', 'Render: spinner (auth check em progresso)');
    return <LoadingGateRecovery gateName="protected-route" spinnerVariant="border-spin" />;
  }

  if (!user) {
    debugLog('warn', 'ProtectedRoute', 'Render: redirect → /auth/login (sem user)');
    return <Navigate to="/auth/login" replace />;
  }

  if (requireAdmin && user.role !== 'admin') {
    debugLog('warn', 'ProtectedRoute', 'Render: redirect → /dashboard (não é admin)');
    return <Navigate to="/dashboard" replace />;
  }

  if (requireSuperAdmin && !user.is_superadmin) {
    debugLog('warn', 'ProtectedRoute', 'Render: redirect → /dashboard (não é superadmin)');
    return <Navigate to="/dashboard" replace />;
  }

  debugLog('info', 'ProtectedRoute', `Render: pass-through (user: ${user.email})`);
  return <Outlet />;
};
